import React from 'react';
import { Facebook, Youtube, Linkedin, Instagram, Mail } from 'lucide-react';
import { Capacitor } from '@capacitor/core';

const isTV = Capacitor.isNativePlatform();

const Footer = () => {
  return (
    <footer className="bg-white">
      <div className="px-8 md:px-16 py-8">
        <div className={`grid grid-cols-1 ${isTV ? 'md:grid-cols-3' : 'md:grid-cols-4'} gap-8`}>

          {/* Category Column */}
          <div>
            <h3 className="text-lg text-black font-bold mb-4">Category</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="hover:text-black cursor-pointer transition">Education</li>
              <li className="hover:text-black cursor-pointer transition">Movies</li>
              <li className="hover:text-black cursor-pointer transition">Series</li>
              <li className="hover:text-black cursor-pointer transition">Live</li>
              <li className="hover:text-black cursor-pointer transition">Music</li>
            </ul>
          </div>

          {/* General Column */}
          <div>
            <h3 className="text-lg text-black font-bold mb-4">General</h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="hover:text-black cursor-pointer transition">About Us</li>
              <li className="hover:text-black cursor-pointer transition">Terms & Conditions</li>
              <li className="hover:text-black cursor-pointer transition">Privacy Policy</li>
              <li className="hover:text-black cursor-pointer transition">Refund Policy</li>
              <li className="hover:text-black cursor-pointer transition">Contact Us</li>
              <li className="hover:text-black cursor-pointer transition">FAQ</li>
            </ul>
          </div>

          {/* Follow us & Get in touch */}
          <div>
            <h3 className="text-lg text-black font-bold mb-4">Follow us on</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="text-gray-600 hover:text-black transition"><Facebook className="w-5 h-5" /></a>
              <a href="#" className="text-gray-600 hover:text-black transition"><Youtube className="w-5 h-5" /></a>
              <a href="#" className="text-gray-600 hover:text-black transition"><Linkedin className="w-5 h-5" /></a>
              <a href="#" className="text-gray-600 hover:text-black transition"><Instagram className="w-5 h-5" /></a>
            </div>

            <h3 className="text-lg text-black font-bold mb-4">Get in touch</h3>
            <div className="flex items-start space-x-2 text-gray-600 text-sm">
              <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
              <span>isfinfomaticaanalytica.com</span>
            </div>

            {/* Download buttons - TV pe bhi dikhenge */}
            {isTV && (
              <div className="mt-6 space-y-3">
                <a href="#" className="block w-fit">
                  <div className="bg-black rounded-lg px-4 py-2 flex items-center space-x-3 hover:bg-gray-800 transition">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="white">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                    <div className="text-left text-white">
                      <div className="text-xs text-gray-400">Download on the</div>
                      <div className="text-sm font-semibold">App Store</div>
                    </div>
                  </div>
                </a>
                <a href="#" className="block w-fit">
                  <div className="bg-black rounded-lg px-4 py-2 flex items-center space-x-3 hover:bg-gray-800 transition">
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="white">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                    <div className="text-left text-white">
                      <div className="text-xs text-gray-400">GET IT ON</div>
                      <div className="text-sm font-semibold">Google Play</div>
                    </div>
                  </div>
                </a>
              </div>
            )}
          </div>

          {/* Phone Mockup Column - ONLY on website, not TV */}
          {!isTV && (
            <div className="relative min-h-[300px]">
              <div className="pr-52">
                <h3 className="text-lg text-black font-bold mb-4">Download Our AthenaStar App</h3>
                <p className="text-gray-600 text-sm mb-6">
                  Experience seamless learning with the AthenaStar app—premium courses, smart features, and easy access in one place.
                </p>
                <div className="space-y-3">
                  <a href="#" className="block">
                    <div className="bg-black rounded-lg px-4 py-2 flex items-center space-x-3 hover:bg-gray-800 transition">
                      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="white">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                      </svg>
                      <div className="text-left">
                        <div className="text-xs text-gray-400">Download on the</div>
                        <div className="text-sm font-semibold text-white">App Store</div>
                      </div>
                    </div>
                  </a>
                  <a href="#" className="block">
                    <div className="bg-black rounded-lg px-4 py-2 flex items-center space-x-3 hover:bg-gray-800 transition">
                      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="white">
                        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                      </svg>
                      <div className="text-left">
                        <div className="text-xs text-gray-400">GET IT ON</div>
                        <div className="text-sm font-semibold text-white">Google Play</div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Phone Mockup */}
              <div className="absolute right-0" style={{ top: '-88px' }}>
                <div className="relative w-48 h-96 bg-black rounded-[2.5rem] border-[10px] border-gray-700 shadow-2xl overflow-hidden">
                  <div className="absolute inset-0 bg-white overflow-hidden">
                    <div className="bg-white border-b border-gray-200 px-3 py-2 flex items-center justify-between">
                      <div className="flex items-center space-x-1.5">
                        <div className="w-7 h-7 bg-teal-500 rounded-lg flex items-center justify-center">
                          <span className="text-white font-bold text-sm">A</span>
                        </div>
                        <span className="text-gray-900 font-bold text-sm">AthenaStar</span>
                      </div>
                    </div>
                    <div className="p-2.5 space-y-2.5 bg-gray-50 h-full pb-16 overflow-y-auto">
                      <div className="relative rounded-xl h-24 overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1509347528160-9a9e33742cdb?w=1200&h=600&fit=crop" alt="Featured" className="w-full h-full object-cover" />
                        <div className="absolute inset-0 flex items-center justify-center">
                          <button className="bg-white text-gray-900 text-xs px-3 py-1.5 rounded-full font-bold flex items-center space-x-1">
                            <span>▶</span><span>Watch</span>
                          </button>
                        </div>
                      </div>
                      <div className="flex items-center justify-between px-0.5">
                        <h3 className="text-gray-900 font-bold text-sm">Popular</h3>
                        <span className="text-blue-600 text-xs font-semibold">All →</span>
                      </div>
                      <div className="grid grid-cols-3 gap-1.5">
                        {[
                          { src: 'photo-1536440136628-849c177e76a1', rating: '8.5' },
                          { src: 'photo-1485846234645-a62644f84728', rating: '7.8' },
                          { src: 'photo-1594908900066-3f47337549d8', rating: '8.9' },
                          { src: 'photo-1478720568477-152d9b164e26', rating: '8.2' },
                          { src: 'photo-1440404653325-ab127d49abc1', rating: '7.5' },
                          { src: 'photo-1535016120720-40c646be5580', rating: '8.7' },
                        ].map((m, i) => (
                          <div key={i} className="relative bg-gray-200 rounded-lg overflow-hidden h-20">
                            <img src={`https://images.unsplash.com/${m.src}?auto=format&fit=crop&w=200&q=80`} alt="" className="w-full h-full object-cover" />
                            <div className="absolute top-1 left-1 bg-yellow-400 text-gray-900 text-xs px-1 rounded font-bold">{m.rating}</div>
                          </div>
                        ))}
                      </div>
                      <div className="bg-white rounded-xl p-3 shadow-lg border border-gray-200">
                        <div className="text-xs text-gray-500 font-semibold mb-1.5">Rating</div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-end">
                            <span className="text-3xl font-bold text-gray-900">4.5</span>
                            <span className="text-xs text-gray-400 ml-1 mb-1">/ 5</span>
                          </div>
                          <div className="text-right">
                            <div className="text-yellow-400 text-sm">★★★★☆</div>
                            <div className="text-xs text-gray-500">2.5K</div>
                          </div>
                        </div>
                        <div className="mt-2 bg-gray-200 rounded-full h-1.5">
                          <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-full h-1.5" style={{ width: '68%' }}></div>
                        </div>
                      </div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-2.5 px-3 flex justify-around items-center">
                      <svg className="w-4 h-4 text-teal-500" fill="currentColor" viewBox="0 0 24 24"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/></svg>
                      <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-300 px-8 md:px-16 py-3">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
          <div className="mb-2 md:mb-0">©2025 ISF Analytica and Informatica Private Limited | All Rights Reserved.</div>
          <div className="flex space-x-6">
            <a href="#" className="hover:text-black transition">Privacy Policy</a>
            <a href="#" className="hover:text-black transition">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;